/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Container = styled.div`
  height: 800px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const Context = styled.div`
  width: 55%;
  height: 80%;
  background-color: #fff;

  padding: 15px;
  border-radius: 20px;

  img {
    width: 100%;
    height: 200px;
    margin-bottom: 30px;
  }

  p.description {
    font-size: 18px;
    line-height: 30px;
    font-weight: bold;
    margin: 10px;
  }

  p {
    font-size: 16px;
    line-height: 30px;
  }
`;

export const ViewForm = styled.div`
  width: 35%;
  height: 80%;

  padding: 20px;

  p.disciple {
    color: #36ded6;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  form.disciple {
    textarea {
      background-color: rgba(0, 0, 0, 0);
      border: 1px solid #fff;
      resize: none;
      width: 100%;
      height: 180px;
      color: #fff;
      border-color: #36ded6;
      padding: 10px;
      font-size: 18px;
      border-radius: 5px;
    }
    button {
      background-color: #36ded6;
      padding: 10px;
      border: none;
      font-weight: bold;
      width: 200px;
      border-radius: 5px;
      margin-top: 10px;
    }
  }

  p.tutoring {
    color: #f7df1e;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
    margin-top: 50px;
  }
  form.tutoring {
    textarea {
      background-color: rgba(0, 0, 0, 0);
      border: 1px solid #fff;
      resize: none;
      width: 100%;
      height: 180px;
      color: #fff;
      border-color: #f7df1e;
      padding: 10px;
      font-size: 18px;
      border-radius: 5px;
    }
    button {
      background-color: #f7df1e;
      padding: 10px;
      border: none;
      font-weight: bold;
      width: 200px;
      border-radius: 5px;
      margin-top: 10px;
    }
  }
`;
